var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.976,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5078 1.68038C15.6405 1.66787 15.7708 1.68089 15.8984 1.71944C14.3353 3.21678 13.1504 4.97459 12.3438 6.99288C11.6121 8.75819 11.0782 10.5811 10.7422 12.4616C8.08539 12.4876 5.42918 12.4616 2.77344 12.3835C5.37862 6.8614 9.62344 3.29369 15.5078 1.68038Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.976,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0234 1.75781C24.0701 1.70792 24.1352 1.68188 24.2188 1.67969C30.2182 3.21354 34.5281 6.78125 37.1484 12.3828C34.4927 12.4609 31.8365 12.487 29.1797 12.4609C28.6048 8.92344 27.2636 5.72029 25.1562 2.85156C24.7889 2.4711 24.4113 2.10652 24.0234 1.75781Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.987,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3359 2.46035C20.4602 2.32739 21.4498 2.62687 22.3047 3.35878C23.6736 4.67598 24.7023 6.22546 25.3906 8.00722C25.9413 9.45089 26.3971 10.9223 26.7578 12.4213C22.2266 12.4734 17.6953 12.4734 13.1641 12.4213C13.6939 9.94597 14.5923 7.61528 15.8594 5.4291C16.4645 4.45928 17.2327 3.63897 18.1641 2.96816C18.5443 2.75143 18.9349 2.58217 19.3359 2.46035Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83594 14.9609C4.64844 14.9609 7.46094 14.9609 10.2734 14.9609C9.96094 18.2943 9.96094 21.6276 10.2734 24.9609C7.46094 24.9609 4.64844 24.9609 1.83594 24.9609C1.0026 21.6276 1.0026 18.2943 1.83594 14.9609Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.995,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7727 14.9629C17.5647 14.9369 22.3563 14.9629 27.1477 15.041C27.4032 16.6701 27.5074 18.3107 27.4602 19.9629C27.507 21.615 27.4028 23.2556 27.1477 24.8848C22.3561 24.9889 17.5644 24.9889 12.7727 24.8848C12.5173 23.2557 12.4131 21.6151 12.4602 19.9629C12.417 18.2849 12.5213 16.6183 12.7727 14.9629Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6484 14.9609C32.4609 14.9609 35.2734 14.9609 38.0859 14.9609C38.918 18.2941 38.918 21.6274 38.0859 24.9609C35.2734 24.9609 32.4609 24.9609 29.6484 24.9609C29.9609 21.6276 29.9609 18.2943 29.6484 14.9609Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.976,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77344 27.4609C5.42969 27.4609 8.08594 27.4609 10.7422 27.4609C11.321 31.0385 12.6882 34.2677 14.8438 37.1484C15.1953 37.5 15.5469 37.8516 15.8984 38.2031C14.9884 38.0824 14.103 37.848 13.2422 37.5C8.40992 35.5452 4.92034 32.1988 2.77344 27.4609Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.987,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1641 27.5406C17.6822 27.4496 22.2134 27.4365 26.7578 27.5015C26.213 30.1787 25.2104 32.6657 23.75 34.9625C21.224 38.2958 18.6979 38.2958 16.1719 34.9625C14.7176 32.6694 13.7149 30.1954 13.1641 27.5406Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.976,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1797 27.4629C31.8365 27.4369 34.4927 27.4629 37.1484 27.541C34.6903 32.8592 30.6538 36.3618 25.0391 38.0488C24.7067 38.1648 24.3682 38.2169 24.0234 38.2051C25.4209 36.9081 26.5016 35.3847 27.2656 33.6348C28.1573 31.6565 28.7954 29.5991 29.1797 27.4629Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.4e14ab1f56d7398944dc911c1c57008f.svg";
export { ForwardRef as ReactComponent };